import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  breakWord: {
    wordBreak: 'break-all',
    fontSize: '1.15em',
    lineHeight: 1.5,
  },
  breakWordd: {
    wordBreak: 'break-all',
  },
  editButton: {
    marginTop: -8,
    marginLeft: 4,
  },
  editableText: {
    marginTop: -8,
    wordBreak: 'break-all',
  },
});
